import React from 'react'
import {
  Button,
  Tag,
  Table,
  Dropdown,
  Menu,
  Tooltip,
  message,
  Row,
  Col
} from 'antd'
import Widget from './Widget'
import {
  fetchTackStatus,
  getDecryptID,
  loadTrackBoxColor
} from '../../appRedux/actions'
import { SALE_TRACKING } from '../../constants/StoreSetting'
import ds from '../../Services/DataServices'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import moment from 'moment'
import { useDispatch } from 'react-redux'

//create your forceUpdate hook
function useForceUpdate () {
  const [value, setValue] = React.useState(0) // integer state
  return () => setValue(value => value + 1) // update state to force render
  // An function that increment 👆🏻 the previous state like here
  // is better than directly setting `value + 1`
}

const TrackCard = props => {
  const { data, isPreparing, pinch, pinchPrep, isUpdate } = props
  const forceUpdate = useForceUpdate()
  const dispatch = useDispatch()

  const [allBtnClick, setAllBtnClick] = React.useState(false)
  const [showCancel, setShowCancel] = React.useState(false)
  const [showServed, setShowServed] = React.useState(false)
  const [pinchData, setPinchData] = React.useState(false)
  const [getData, setTabData] = React.useState([])
  const [icon, setIcon] = React.useState('schedule')
  const [hours, setHours] = React.useState(0)
  const [minutes, setMinutes] = React.useState(0)
  const [seconds, setSeconds] = React.useState(0)
  const [timerDone, setTimerDone] = React.useState(false)
  const [bgColor, setbgColor] = React.useState('order-placed')

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let putData = { ...data }
      if (putData) {
        setAllBtnClick(true)
        if (putData.saleTrack && putData.saleTrack.length > 0) {
          //filters
          if (!showCancel) {
            const da = putData.saleTrack.filter(
              a => fetchTackStatus(getDecryptID(a.orderStatus)) != 'CANCEL'
            )
            putData.saleTrack = da
          }
          if (!showServed) {
            const daf = putData.saleTrack.filter(
              a => fetchTackStatus(getDecryptID(a.orderStatus)) != 'SERVED'
            )
            putData.saleTrack = daf
          }
        }

        //icon
        let readyServed = true
        putData.saleTrack &&
          putData.saleTrack.map(a => {
            if (a.orderStatus) {
              if (
                getDecryptID(a.orderStatus) !=
                  SALE_TRACKING.filter(b => b.NAME == 'READY')[0].ID &&
                getDecryptID(a.orderStatus) !=
                  SALE_TRACKING.filter(b => b.NAME == 'SERVED')[0].ID
              ) {
                readyServed = false
                return
              }
            }
          })
        setIcon(readyServed ? 'check-circle-o' : 'schedule')
        if (putData && putData.saleTrack && putData.saleTrack.length > 0) {
          const ifAllServed = putData.saleTrack.filter(
            a =>
              getDecryptID(a.orderStatus) ==
              SALE_TRACKING.filter(a => a.NAME == 'SERVED')[0].ID
          )
          const ifAllReady = putData.saleTrack.filter(
            a =>
              getDecryptID(a.orderStatus) ==
              SALE_TRACKING.filter(a => a.NAME == 'READY')[0].ID
          )
          const ifAllInProgress = putData.saleTrack.filter(
            a =>
              getDecryptID(a.orderStatus) ==
              SALE_TRACKING.filter(a => a.NAME == 'PREPARING')[0].ID
          )

          if (ifAllServed && ifAllServed.length == putData.saleTrack.length) {
            setbgColor('order-served')
          } else if (
            ifAllReady &&
            ifAllReady.length == putData.saleTrack.length
          ) {
            setbgColor('order-ready')
          } else if (
            ifAllInProgress &&
            ifAllInProgress.length == putData.saleTrack.length
          ) {
            setbgColor('order-preparing')
          }
        }
        setTabData(putData)
        setAllBtnClick(false)
        forceUpdate()
      }
    }
    return () => (mounted = false)
  }, [data, showCancel, showServed, pinchData])

  React.useEffect(() => {
    let myInterval = setInterval(() => {
      if (!timerDone) {
        timerFn()
        setTimerDone(true)
      } else {
        if (seconds > 0 || seconds == 0) {
          setSeconds(seconds + 1)
        }
        if (seconds === 60) {
          setMinutes(minutes + 1)
          setSeconds(1)
        }
        if (minutes === 60) {
          setHours(hours + 1)
          setMinutes(1)
        }
      }
    }, 1000)
    return () => {
      clearInterval(myInterval)
    }
  })

  async function postSalesLogs (body, isPinch) {
    if (!isUpdate) {
      setAllBtnClick(true)
      const resp = ds.postSaleLogsService(body, BEHAVIOUR_TYPE.POST)
      await resp
        .then(res => {
          setAllBtnClick(false)
          if (
            body &&
            res &&
            getData &&
            getData.saleTrack &&
            getData.saleTrack.length > 0 &&
            res.orderTrackingIDs &&
            res.orderTrackingIDs.length > 0
          ) {
            let newData = getData
            if (body.IsAll) {
              newData.saleTrack
                .filter(
                  x =>
                    fetchTackStatus(getDecryptID(x.orderStatus)) != 'CANCEL' &&
                    fetchTackStatus(getDecryptID(x.orderStatus)) != 'SERVED'
                )
                .map(a => {
                  a.orderStatus = `${body.OrderStatus}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
                  a.orderTrackingID =
                    res.orderTrackingIDs.filter(
                      xa =>
                        getDecryptID(xa.trackID) ==
                        getDecryptID(a.orderTrackingID)
                    ).length > 0
                      ? res.orderTrackingIDs.filter(
                          xa =>
                            getDecryptID(xa.trackID) ==
                            getDecryptID(a.orderTrackingID)
                        )[0].newTrackID
                      : a.orderTrackingID
                })
              setPinchData(!pinchData)
              if (isPinch && !isPreparing) {
                pinch()
                pinchPrep()
              }
            } else if (body.TrackItemID) {
              newData.saleTrack
                .filter(
                  x =>
                    getDecryptID(x.orderTrackingID) ==
                    getDecryptID(body.TrackItemID)
                )
                .map(a => {
                  a.orderStatus = `${body.OrderStatus}&&_9efa-1ea9-4faf-88ed-a48e22365b46643`
                  a.orderTrackingID = res.orderTrackingIDs[0].newTrackID
                })
              setPinchData(!pinchData)
              if (isPinch && !isPreparing) {
                pinch()
                pinchPrep()
              }
            }
            setTabData(newData)
            forceUpdate()
          } else {
            // message.warn("Something is fishy, kindly refresh..!", 4);
          }
        })
        .catch(e => {
          // setTableData([]);
          setAllBtnClick(false)
        })
    } else {
      message.warn('Do not have Right to update!', 5)
    }
  }

  function timerFn () {
    let hourDiff = 0
    let minDiff = 0
    let secDiff = 0
    if (data && data.createdOn) {
      const startTime = new Date(data.createdOn)
      const endTime = new Date()
      // const difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
      // const resultInMinutes = Math.round(difference / 60000);
      hourDiff = endTime.getHours() - startTime.getHours()
      minDiff = endTime.getMinutes() - startTime.getMinutes()
      secDiff = endTime.getSeconds() - startTime.getSeconds()
    }
    setHours(hourDiff && hourDiff > 0 ? hourDiff : 0)
    setMinutes(minDiff && minDiff > 0 ? minDiff : 0)
    setSeconds(secDiff && secDiff > 0 ? secDiff : 0)
  }

  const columns = [
    {
      title: 'NAME',
      dataIndex: 'name',
      // className: "tab-bckg-ch",
      render: (text, record) => {
        return (
          <>
            <span>{text}</span>
            {record.note ? (
              <>
                <br />
                <strong>NOTE:</strong>
                <br />
                <p style={{ fontSize: 'smaller' }}>{record.note}</p>
              </>
            ) : (
              ''
            )}
          </>
        )
      }
    },
    {
      title: 'QUANTITY',
      align: 'center',
      dataIndex: 'quantity',
      render: text => {
        return <span style={{ alignItems: 'center' }}>{text}</span>
      }
    },
    {
      title: 'STATUS',
      dataIndex: 'orderStatus',
      render: text => {
        const id = text ? getDecryptID(text) : ''
        let clr =
          id == '1'
            ? 'purple'
            : id == '2'
            ? '' //lime
            : id == '3'
            ? 'green'
            : id == '4'
            ? '' // geekblue
            : id == '5'
            ? 'red'
            : id == '6'
            ? 'gold'
            : 'magenta'
        return (
          <Tag
            className='status-tags'
            color={clr}
            style={{
              color:
                id == '2'
                  ? 'rgb(24, 144, 255)'
                  : id == '4'
                  ? 'rgb(95 212 49)'
                  : ''
            }}
          >
            {fetchTackStatus(text) == 'PREPARING'
              ? 'IN PROGRESS'
              : fetchTackStatus(text)}
          </Tag>
        )
      }
    },
    {
      title: 'ACTION',
      align: 'center',
      dataIndex: 'action',
      render: (text, record) => {
        return (
          <ul className='gx-list-inline gx-ml-auto gx-mb-0'>
            <li>
              {!isUpdate ? (
                <>
                  {record.orderStatus &&
                  (fetchTackStatus(record.orderStatus) == 'CANCEL' ||
                    fetchTackStatus(record.orderStatus) == 'SERVED') ? (
                    <span className='gx-link ant-dropdown-link'>
                      <i
                        className='icon icon-sweet-alert'
                        style={{ color: '#453a3aab' }}
                      />
                    </span>
                  ) : (
                    <Dropdown
                      overlayStyle={{
                        border: '1px solid rgb(250, 140, 22)',
                        borderRadius: 4
                      }}
                      overlay={<MenuAction lineItem={record} />}
                      trigger={['click']}
                    >
                      <span className='gx-link ant-dropdown-link'>
                        <i className='icon icon-chevron-down' />
                      </span>
                    </Dropdown>
                  )}
                </>
              ) : (
                <>
                  <Tooltip title={'DO NOT HAVE RIGHT TO UPDATE!'}>
                    <span className='gx-link ant-dropdown-link'>
                      <i
                        className='icon icon-sweet-alert'
                        style={{ color: '#453a3aab' }}
                      />
                    </span>
                  </Tooltip>
                </>
              )}
            </li>
          </ul>
        )
      }
    }
  ]

  const menu = (
    <Menu>
      <Menu.Item key='0' onClick={() => setShowServed(!showServed)}>
        {showServed && (
          <i
            className='icon icon-check-circle-o gx-mr-2'
            style={{ color: 'green' }}
          />
        )}
        <a>Show Served</a>
      </Menu.Item>
      {/* <Menu.Item key="1">
        <a>Search All Placed</a>
      </Menu.Item> */}
      {/* <Menu.Item key="2">
        <a>Search All Preparing</a>
      </Menu.Item>
      <Menu.Item key="3">
        <a>Search All Ready</a>
      </Menu.Item>
      <Menu.Item key="4">
        <a>Search All Served</a>
      </Menu.Item>
      <Menu.Item key="6">
        <a>Search All Changed</a>
      </Menu.Item> */}
      <Menu.Divider />
      <Menu.Item onClick={() => setShowCancel(!showCancel)} key='5'>
        {showCancel && (
          <i
            className='icon icon-check-circle-o gx-mr-2'
            style={{ color: 'green' }}
          />
        )}
        <a>Show Canceled</a>
      </Menu.Item>
    </Menu>
  )

  const MenuAction = propss => {
    const { lineItem } = propss
    return (
      <Menu onClick={e => onMarkClick(e, lineItem)}>
        {isPreparing ? (
          <>
            <Menu.Item
              key={SALE_TRACKING.filter(a => a.NAME == 'PREPARING')[0].ID}
            >
              <a>Mark In Progress</a>
            </Menu.Item>
            <Menu.Item key={SALE_TRACKING.filter(a => a.NAME == 'READY')[0].ID}>
              <a>Mark Ready</a>
            </Menu.Item>
          </>
        ) : (
          <>
            <Menu.Item
              key={SALE_TRACKING.filter(a => a.NAME == 'SERVED')[0].ID}
            >
              <a>Mark Served</a>
            </Menu.Item>
          </>
        )}
      </Menu>
    )
  }

  function evenOrOdd (num) {
    if (num % 2 == 0) {
      return 'even'
    } else {
      return 'odd'
    }
  }

  function onMarkClick (e, item) {
    if (e.key && item) {
      const body = {
        OrderStatus: parseInt(e.key),
        TrackItemID: item.orderTrackingID,
        SalesOrderID: getData.salesOrderID,
        IsAll: false
      }
      postSalesLogs(
        body,
        parseInt(e.key) == SALE_TRACKING.filter(a => a.NAME == 'SERVED')[0].ID
          ? true
          : false
      )
    }
  }

  function onAllBtnClick (status) {
    if (
      status &&
      getData &&
      getData.salesOrderID &&
      getData.saleTrack &&
      getData.saleTrack.length > 0
    ) {
      const body = {
        OrderStatus: status,
        SalesOrderID: getData.salesOrderID,
        IsAll: true
      }
      postSalesLogs(
        body,
        status == SALE_TRACKING.filter(a => a.NAME == 'SERVED')[0].ID
          ? true
          : false
      )
    }
  }

  return (
    <Widget styleName='gx-widget-bg' bgColor={bgColor}>
      <div className='sale-Card-Header'>
        {getData && getData.salesOrderID && (
          <Row className='mb-2'>
            <Col span={8}>
              <Tooltip
                title={
                  <p style={{ fontSize: 10 }}>
                    Ref # {getDecryptID(getData.salesOrderID)}
                  </p>
                }
              >
                <span className='text-color-white'>
                  Order #{' '}
                  {getData && getData.receiptCode
                    ? `${getDecryptID(getData.receiptCode)}`
                    : ' '}
                </span>
              </Tooltip>
            </Col>
            <Col span={8}>
              {hours === 0 && minutes === 0 && seconds === 0 ? (
                <p className='text-color-white mb-0 text-center'>00:00:00</p>
              ) : (
                <p className='text-color-white mb-0 text-center'>
                  {hours < 10 ? `0${hours}` : hours}:
                  {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </p>
              )}
            </Col>
            <Col span={8} className='text-right'>
              <p className='text-color-white mb-0'>
                {getData.createdOn
                  ? `${moment(getData.createdOn).format('DD/MM/YYYY HH:mm')}`
                  : ''}
              </p>
            </Col>
          </Row>
        )}
        {getData &&
          getData.saleAttributes &&
          getData.saleAttributes.length > 0 && (
            <Row>
              <Col span={24}>
                {getData.saleAttributes.map((as, io) => {
                  const isEvenOrOdd = evenOrOdd(io)
                  return (
                    <>
                      <Tag className='tracking-tag' key={io}>
                        {as ? `${as}` : ''}
                      </Tag>
                    </>
                  )
                })}
              </Col>
            </Row>
          )}

        <div className='d-flex align-items-center justify-content-between header-btns-div'>
          <i
            style={{ display: 'contents' }}
            className={`icon icon-${icon} gx-fs-xlxl text-color-white`}
          />

          <span className='sale-tracking-btn'>
            {isPreparing ? (
              <>
                <Tooltip
                  placement='topLeft'
                  title={`${
                    !isUpdate
                      ? 'Mark all items "PREPARING"'
                      : 'DO NOT HAVE RIGHT TO UPDATE!'
                  }`}
                >
                  <Button
                    onClick={() => {
                      onAllBtnClick(
                        SALE_TRACKING.filter(a => a.NAME == 'PREPARING')[0].ID
                      )
                      // dispatch(loadTrackBoxColor('order-preparing'))
                      setbgColor('order-preparing')
                    }}
                    loading={allBtnClick}
                    size='small'
                    // className="gx-btn-warning"
                    type='primary'
                  >
                    All In Progress
                  </Button>
                </Tooltip>
                <Tooltip
                  placement='topRight'
                  title={`${
                    !isUpdate
                      ? 'Mark all items "READY"'
                      : 'DO NOT HAVE RIGHT TO UPDATE!'
                  }`}
                >
                  <Button
                    onClick={() => {
                      onAllBtnClick(
                        SALE_TRACKING.filter(a => a.NAME == 'READY')[0].ID
                      )
                      // dispatch(loadTrackBoxColor('order-ready'))
                      setbgColor('order-ready')
                    }}
                    loading={allBtnClick}
                    size='small'
                    className='dk-btn-add'
                    type='primary'
                  >
                    All Ready
                  </Button>
                </Tooltip>
              </>
            ) : (
              <>
                <Tooltip
                  placement='topRight'
                  title={`${
                    !isUpdate
                      ? 'Mark all items "SERVED"'
                      : 'DO NOT HAVE RIGHT TO UPDATE!'
                  }`}
                >
                  <Button
                    onClick={() => {
                      onAllBtnClick(
                        SALE_TRACKING.filter(a => a.NAME == 'SERVED')[0].ID
                      )
                      dispatch(loadTrackBoxColor('order-served'))
                    }}
                    loading={allBtnClick}
                    size='small'
                    style={{ background: '#2da290' }}
                    // className="gx-btn-warning"
                    type='primary'
                  >
                    All Served
                  </Button>
                </Tooltip>
              </>
            )}
          </span>

          <ul className='gx-list-inline gx-text-grey m-0'>
            <li>
              <Dropdown overlayStyle={{}} overlay={menu} trigger={['click']}>
                <span className='gx-link ant-dropdown-link gx-text-grey'>
                  <i className='icon icon-chevron-down arrow-ul text-color-white' />
                </span>
              </Dropdown>
            </li>
          </ul>
        </div>
      </div>

      <div className='gx-table-responsive'>
        <Table
          style={{ background: 'inherit', color: '#ffff', marginTop: 8 }}
          className='tab-bckg-ch'
          rowClassName={(record, index) =>
            fetchTackStatus(record.orderStatus) == 'CANCEL' ||
            fetchTackStatus(record.orderStatus) == 'SERVED'
              ? `tab-row-${
                  fetchTackStatus(record.orderStatus) == 'SERVED'
                    ? 'gray'
                    : 'red'
                }`
              : ''
          }
          columns={columns}
          loading={allBtnClick}
          dataSource={getData && getData.saleTrack ? getData.saleTrack : []}
          pagination={false}
          bordered={false}
          size='small'
        />
      </div>

      {getData && getData.note && getData.note != '' && (
        <p
          className='gx-fs gx-font-weight-semi-bold'
          style={{ color: '#fff', marginTop: 2 }}
        >
          <strong>Order Note: </strong>
          {getData.note}
        </p>
      )}
    </Widget>
  )
}

export default TrackCard
